import React from 'react';
import Api from '../gd/api/api';

import ModalDeleteProject from "core/gd-modals/project/delete/delete-project";
import ModalReassignProjectItems from "./project/reassign-items/reassign-items";
import NewProjectViewModal from "./project/new-project-view/new-project-view";
import ModalProjectViewSaveAs from "./project/project-view-save-as/modal-project-view-save-as";

import PlanningManger from "../gd/manager/planning-manager";
import NewProjectCollectionViewModal from "./project/new-project-view/new-project-collection-view";
import ModalProjectLink from "./link-entity/project-link/project-link";
import ModalProjectConvertNew from "./project/convert/project-convert-new";
import projectConvert_checkDocumentAndConfirm from "./project/convert/functions/check-and-confirm-page-convert";
import ModalUpdateStatus from "./update-status/update-status-modal"
import ModalEditProject from "./project/edit-project/modal-edit-project"
import {modalMoveProject} from "core/gd-modals/move-to/move"
import {modalCopyProject} from "./copy/copy"
import ModalUserView from "./project-users/project-user-edit/modal-project-user";
import ModalTeamView from "./project-users/project-team-edit/modal-project-team";
import ApiProject from "../gd/api/project";

export default class ProjectModalsManager {

    constructor() {}

    projectViewSaveAs(callback) {
        gd.modal.showForm({
            header: {
                title: 'Save as'
            },
            className: 'modal-save-as-existing-preset',
            component: ModalProjectViewSaveAs,
            params: {
                onSubmit: (values)=>{
                    gd.modal.hide();
                    if (callback) callback(values);
                }
            }
        });
    }

    newProjectView(projectId, name, callback) {
        gd.modal.showForm({
            header: {
                title: 'New project view'
            },
            className: 'modal-save-new-preset',
            component: NewProjectViewModal,
            params: {
                projectId,
                name,
                onSubmit: (values)=>{
                    gd.modal.hide();
                    if (callback) callback(values);
                }
            }
        });
    }

    newProjectCollectionView(name, callback) {
        gd.modal.showForm({
            header: {
                title: 'New project collection view'
            },
            className: 'modal-save-new-preset',
            component: NewProjectCollectionViewModal,
            params: {
                name,
                onSubmit: (values)=>{
                    gd.modal.hide();
                    if (callback) callback(values);
                }
            }
        });
    }

    exportToCSV(exportType, exportDataManager) {
        gd.modal.showV4({
            className: 'modal-export-to-csv-with-columns',
            component: require('./export-to-csv-module/modal-export-to-csv-module'),
            params: {
                exportType,
                exportDataManager,
                onSubmit: ()=>{
                    gd.modal.hide();
                }
            }
        });
    }

    exportProjectTasks(projectId, tasksIds) {

        const options = [
            { value: 'all', label: 'Export all', description: 'Export all items'},
            { value: 'current', label: 'Export current view', description: 'Export filtered items you see in the current view'},
        ];

        gd.modal.showForm({
            className: 'modal-export-to-csv',
            header: {
                title: 'Export to CSV'
            },
            component: require('./export-to-csv/modal-export-to-csv.jsx'),
            params: {
                options,
                defaultValue: 'all',
                onSubmit: (values)=>{
                    const project = gd.session.projects.get(projectId);
                    let tasksUrl = gdConfig.apiUrl+"company/"+project.companyId+"/export-csv/tasks";

                    if (tasksIds.length === 0) values.selectedOption = "all";

                    switch (values.selectedOption){
                        case "current":
                            if (tasksIds){
                                tasksIds.map((id,key)=>{
                                    tasksUrl += (key === 0 ? "?" : "&") + "taskIds="+id;
                                });
                            }
                            break;
                        case "all":     tasksUrl += "?projectId="+projectId; break;
                    }
                    tasksUrl += "&" + gd.auth.argsParams;
                    gd.openInNewWindow(tasksUrl)
                    gd.modal.hide();
                }
            }
        });
    }


    editTaskTypesList(companyId, projectId, callback) {
        gd.modal.showV4({
            className: 'modal-edit-task-types-list',
            component: require('./edit-task-types-list/edit-task-types-list.jsx'),
            params: {
                onSubmit: (arrayTaskTypesIds)=> {
                    if (callback) callback(arrayTaskTypesIds);
                    gd.modal.hide();
                },
                companyId: companyId,
                projectId: projectId
            }
        });
    }

    // THIS IS OLD BUT WORKING NOT IN USE AT THE MOMENT
    // addUser(projectId, callback, options={}) {
    //
    //     const className = (options.className)?options.className:'';
    //     const defaultAccess = (options.defaultAccess)?options.defaultAccess:gd.const.project.access.STANDARD;
    //     const showNotifyOnAllTasks = (options.showNotifyOnAllTasks)?options.showNotifyOnAllTasks:false;
    //
    //     gd.modal.showForm({
    //         header: {
    //             title: 'New Project User'
    //         },
    //         name: "addUserToProject",
    //         className: className,
    //         component: require('./add-user-to-project/new-project-user-modal.jsx'),
    //         toggleCallback: options.toggleCallback,
    //         params: {
    //             onSubmit: (values) => {
    //
    //                 const request = Api.Project.addProjectUser(projectId, values.user, values.access, gd.const.project.role.USER, values.watchAll);
    //
    //                 request.done(response=>{
    //                     gd.modal.hide();
    //                     if(callback) callback(values.user);
    //                 });
    //
    //             },
    //             projectId: projectId,
    //             showSelectAccess: true,
    //             showNotifyOnAllTasks: showNotifyOnAllTasks,
    //             selectUser: true,
    //             defaultAccess: defaultAccess
    //         }
    //     });
    // }


    confirmCloseNotEmpty(projectId, newStatusId  /*string*/, newSystemStatus  /*number*/, callback /*func*/) {
        gd.modal.showGeneric({
            header: {
                title: 'Archive a Project'
            },
            component: require('./close-not-empty-project/close-not-empty-modal.jsx'),
            className: 'modal-close-not-empty',
            params: {
                onSubmit(values) {callback(true)},
                onCancel() {callback(false)},
                projectId: projectId,
                newSystemStatus: newSystemStatus,
                newStatusId: newStatusId
                // this: app
            }
        })
    }

    async convert(app, projectId, onConvertCallback) {
        const result = await projectConvert_checkDocumentAndConfirm([projectId])

        if (result) {
            gd.modal.showV4({
                className   : 'modal-project-convert',
                component   : ModalProjectConvertNew,
                params      : {
                    callback(values) {
                        gd.modal.hide()
                        if (onConvertCallback) onConvertCallback(values)
                    },
                    projectId   : projectId
                }
            })
        }
    }

    // this is old
    // rename(projectId, callback) {
    //
    //     const project = gd.session.projects.get(projectId);
    //
    //     return gd.modals.project.edit(project, callback);
    // }

    updateStatus(projectId) {
        gd.modal.showForm({
            className   : 'modal-update-status',
            header      : {
                title: 'Update Status'
            },
            component   : ModalUpdateStatus,
            params      : {
                projectId: projectId
            }
        })
    }

    move(app, projectId, onMoveCallback) {

        const project = gd.session.projects.get(projectId);

        return modalMoveProject(project, {
            callback: onMoveCallback,
        });


        // gd.modal.showV4({
        //     className: 'modal-move',
        //     component: ModalMoveTo,
        //     params: {
        //         companyId: project.companyId,
        //         projectId: projectId,
        //         parentProjectId: project.parentId,
        //         mode: ModalMoveTo_Mode.PROJECT,
        //         type: ModalMoveTo_TargetType.FOLDER,
        //         onMove: onMoveCallback
        //     }
        // });
    }

    deleteProject(deprecated_param, projectId, callback) {
        const project           = gd.session.projects.get(projectId)
        const parentId          = project.parentId
        const app               = gd.getApp()
        const currentProjectId  = app.projectId || app.project?.id || app.view?.parentProjectId

        gd.modal.showForm({
            header      : {
                title       : (
                    <div className="h30">
                        Delete <span className="delete-name">{project.name}</span>
                    </div>
                )
            },
            className   : 'modal-delete-project',
            component   : ModalDeleteProject,
            params      : {
                projectId       : projectId,
                onBeforeDelete  : () => {
                    const childrenProjects = gd.session.projects.get(projectId).childrenProjectsIds.concat([projectId])

                    //check if current project is deleted or current project is one of children of deleted project
                    if (
                        projectId === currentProjectId
                        || childrenProjects.includes(currentProjectId)
                        || project.isView
                    ) {
                        //then we need to redirect to it's parent if able or to my work
                        if (parentId) {
                            gd.goTo('p/'+parentId)
                        } else {
                            gd.goTo('')
                        }
                    } else {
                        callback?.()
                    }
                }
            }
        })
    }

    edit(project, callback) {
        gd.modal.showForm({
            className: 'modal-action-edit',
            header: {
                title: 'Rename'
            },
            component: ModalEditProject,
            params: {
                onSubmit: values=>{
                    // Api.Project.updateProfile(project.id, values);
                    gd.api.Project.update(project.id, values);
                    gd.modal.hide();
                    if (callback) callback(values.name)
                },
                project: project
            }
        });
    }

    editUser(projectUser, projectUsers, callback, userAssignments, viewType) {

        gd.modal.showV4({
            className: 'modal-project-user',
            component: ModalUserView,
            params: {
                onChange        : callback,
                projectUser     : projectUser,
                projectUsers    : projectUsers, // this is full project users collection not sure if we need all or can use sesison
                userAssignments : userAssignments, // contains items to reassign (is used when user delete was called but reassign is needed)
                viewType        : viewType,
                onReassignDone  : callback
            }
        });
    }

    editTeam(projectUser, projectUsers, ownerUserId, callback, userAssignments) {

        gd.modal.showV4({
            className: 'modal-project-user',
            component: ModalTeamView,
            params: {
                onChange        : callback,
                projectUser     : projectUser,
                projectUsers    : projectUsers, // this is full project users collection not sure if we need all or can use sesison
                userAssignments : userAssignments,
                onReassignDone  : callback,
                ownerUserId     : ownerUserId
            }
        })
    }

    /*addUsers(projectId, callback, options={}) {
        gd.modal.showV4({
            className: 'modal-add-user',
            component: require('./add-user/add-user.jsx'),
            params: {
                onSubmit: newProjectUsers=>{
                    const request = Api.Project.addUsers(projectId, newProjectUsers);

                    request.done(response=>{
                        gd.modal.hide();
                        if(callback) callback(newProjectUsers);
                    });
                },
                multiselect: true,
                projectId: projectId,
                mode: 'project'
            }
        });
    }*/

    /*addUser(projectId, callback, options={}) {
        gd.modal.showV4({
            className: 'modal-add-user',
            component: require('./add-user/add-user.jsx'),
            params: {
                onSubmit: function(newProjectUser) {

                    const request = Api.ProjectUser.add(projectId, newProjectUser.userId, newProjectUser.access, gd.const.project.role.USER, false);

                    request.done(response=>{
                        gd.modal.hide();
                        if(callback) callback(newProjectUser.userId);
                    });

                }.bind(this),
                multiselect: false,
                projectId: projectId,
                mode: 'project'
            }
        });
    }*/

    /*addUserWithoutApiCall(projectId, callback) {
        gd.modal.showV4({
            className: 'modal-add-user',
            component: require('./add-user/add-user.jsx'),
            params: {
                onSubmit: (newProjectUser)=>{
                    if(callback) callback(newProjectUser);
                },
                multiselect: false,
                projectId: projectId,
                mode: 'project'
            }
        });
    }*/

    saveAsTemplate(project, callback) {
        modalCopyProject(project, {
            copyAsTemplate: true,
            redirectToCopy: true,
            callback
        })
    }


    duplicate(project, callback, options = {}) {
        const { copyAsTemplate, redirectToCopy } = options;

        modalCopyProject(project, {
            copyAsTemplate,
            redirectToCopy,
            callback
        })
    }

    estimate(projectId, callback) {
        gd.modal.showGeneric({
            className: 'modal-action-estimate',
            header: {
                title: 'Project Estimate'
            },
            component: require('./estimate-task/modal-action-estimate'),
            params: {
                onSubmit: values=>{
                    const estimate = values.hours * 60 + values.minutes;
                    Api.Project.setEstimate(projectId, estimate);
                    if (callback) callback(estimate);
                    gd.modal.hide();
                },
                this: this
            }
        });
    }

    progress(projectId, callback) {
        gd.modal.showGeneric({
            className: 'modal-progress',
            header: {
                title: 'Project Progress'
            },
            component: require('./progress/progress'),
            params: {
                onSubmit: value=>{
                    Api.Project.setProgress(projectId, value);
                    if (callback) callback(value);
                    gd.modal.hide();
                },
            }
        });
    }

    deadline(projectId, callback) {
        gd.modal.showGeneric({
            className: 'modal-action-deadline',
            header: {
                title: 'Project Deadline'
            },
            component: require('./deadline-task/modal-action-deadline'),
            params: {
                onSubmit: values=>{
                    Api.Project.setDeadline(projectId, values.deadline);
                    if (callback) callback(values.deadline);
                    gd.modal.hide();
                },
                this: this
            }
        });
    }

    startEnd(projectId, callback) {
        gd.modal.showForm({
            className: 'modal-action-start-end',
            header: {
                title: 'Project Start / End'
            },
            component: require('./start-end-task/modal-action-stat-end.jsx'),

            params: {
                onSubmit: (values)=>{
                    const startDate = values.startDate ? values.startDate : null;
                    const endDate = values.endDate ? values.endDate : null;
                    const planningResult = PlanningManger.projectStartEnd(projectId, startDate, endDate);
                    if (callback) callback(planningResult.startDate, planningResult.endDate);
                    gd.modal.hide();
                },
            }
        });
    }

    reassignItems(type, projectId, userId, reassignItems, callback) {
        gd.modal.hide(); //another modal className from previous modal remains if no hide called (if reassignItems is called from another modal)

        const user = gd.session.users.get(userId);

        let title;
        switch (type) {
            case 'delete': title = "Delete " + user.name; break;
            case 'access': title = "Update " + user.name + '\'s access'; break;
        }

        gd.modal.showV4({
            className: 'modal-reassign-items',
            header: {
                title: title
            },
            component: ModalReassignProjectItems,
            params: {
                callback: result=>{
                    // const request = gd.api.Project.reassignItems(projectId, userId, result.tasksReassignTo, result.eventsReassignTo, result.projectsReassignTo);
                    const request = ApiProject.reassignItemsV2(projectId, userId, result.tasksReassignTo, result.eventsReassignTo, result.projectsReassignTo);
                    request.done(()=> {
                        if(callback) callback(result);
                        gd.modal.hide();
                    })
                },
                title,
                type,
                projectId,
                userId,
                reassignItems
            }
        });

    }

    projectLink(projectId, callback) {
        gd.modal.showV4({
            className   : 'modal-project-link',
            component   : ModalProjectLink,
            params      : {
                projectId,
                onSubmit: (result)=>{
                    if (callback) callback(result);
                    gd.modal.hide();
                },
            }
        });
    }
}
